import { useSetRecoilState } from 'recoil'
import styled from 'styled-components'

import Pencil from '~/shared/assets/icons/Pencil'
import Tag from '~/shared/components/tags/Tag'
import { isModalOpenState } from '~/shared/states'
import theme from '~/shared/styles/theme'

function MyInfo({ myInfo }: any) {
  const loginType = localStorage.getItem('starlike-login-type')

  const setIsModalOpen = useSetRecoilState(isModalOpenState)

  return (
    <>
      {myInfo && (
        <>
          <InfoBox>
            <TitleBox>
              <Title>내 정보</Title>
              <div
                className="modify_button"
                onClick={() =>
                  setIsModalOpen({
                    contents: 'mypage-modify-info',
                    isOpen: true,
                  })
                }
              >
                <Pencil />
                수정하기
              </div>
            </TitleBox>
            <TagBox className="tag">
              <Tag $size="sm" $variant="gray">
                닉네임
              </Tag>
              <div className="desc">{myInfo.nickname}</div>
            </TagBox>
            <TagBox className="tag">
              <Tag $size="sm" $variant="gray">
                이름
              </Tag>
              <div className="desc">{myInfo.name}</div>
            </TagBox>
            <TagBox className="tag">
              <Tag $size="sm" $variant="gray">
                출생년도
              </Tag>
              <div className="desc">
                {myInfo.year_of_birth ? myInfo.year_of_birth.slice(0, 4) : '-'}
              </div>
            </TagBox>
            <TagBox className="tag">
              <Tag $size="sm" $variant="gray">
                성별
              </Tag>
              <div className="desc">
                {myInfo.gender === 'F'
                  ? '여성'
                  : myInfo.gender === 'M'
                    ? '남성'
                    : '알 수 없음'}
              </div>
            </TagBox>
            <TagBox className="tag">
              <Tag $size="sm" $variant="gray">
                이메일
              </Tag>
              <div className="desc">{myInfo.email}</div>
            </TagBox>
          </InfoBox>
          {loginType !== 'naver' && (
            <InfoBox>
              <TitleBox>
                <Title>비밀번호</Title>
                <span
                  className="modify_button"
                  onClick={() =>
                    setIsModalOpen({
                      contents: 'mypage-change-password',
                      isOpen: true,
                    })
                  }
                >
                  <Pencil />
                  비밀번호 변경
                </span>
              </TitleBox>
              <TagBox className="tag">
                <Tag $size="sm" $variant="gray">
                  비밀번호
                </Tag>
                <div className="desc">*******</div>
              </TagBox>
            </InfoBox>
          )}
        </>
      )}
    </>
  )
}

export default MyInfo

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: space-between;

  box-sizing: border-box;
  width: 100%;
  height: auto;
  padding: 36px 24px;

  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.grey_3};
  border-radius: 12px;

  > span {
    display: flex;
    flex-direction: row;
  }

  > .tag {
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: center;

    @media ${theme.device.medium} {
      flex-direction: column;
      align-items: start;
      width: 100%;
    }
  }

  @media ${theme.device.medium} {
    flex-direction: column;
    width: 100%;
    margin: 0 auto;
  }
`

const TitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .modify_button {
    cursor: pointer;

    display: flex;
    gap: 4px;
    align-items: center;

    margin-bottom: 16px;

    font-family: NanumSquareNeo-Regular, sans-serif;
    color: ${theme.colors.grey_4};
  }

  @media ${theme.device.medium} {
    display: flex;
    flex-direction: row;
    align-items: start;

    width: 100%;
    margin: 0 auto;
  }
`

const Title = styled.h2`
  margin-bottom: 36px;
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;
  font-weight: 700;
`

const TagBox = styled.div`
  display: flex;
  gap: 36px;
  align-items: center;
  width: 100%;

  .desc {
    width: 100%;
    font-family: NanumSquareNeo-Regular, sans-serif;
  }

  .thumbnail {
    width: 132px;
    height: 132px;
    border-radius: 12px;
  }

  @media ${theme.device.medium} {
    flex-direction: column;
    gap: 16px;
    align-items: start;
  }
`
